// Footer.js
import React from "react";
import { useSelector } from "react-redux";
import { Box, Link, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

function Copyright() {
  return (
    <Typography
      sx={{
        fontSize: { xs: 14, md: 16 },
        color: "#fff",
        whiteSpace: "nowrap",
      }}
    >
      Copyright © {new Date().getFullYear()}{" "}
      <Link
        color="inherit"
        href="https://vucaware.com/"
        sx={{ cursor: "pointer", color: "#fff" }}
        target="_blank"
        underline="always"
      >
        Vucaware
      </Link>
    </Typography>
  );
}

export default function HomePageFooter() {
  const location = useLocation();
  const flagValue = useFeatureFlag("vucaware_logo_display");
  const { footerLinks = [] } = useSelector((state) => state.appConfig) || {};

  const socialLinks = [
    {
      icon: <FacebookRoundedIcon fontSize="large" />,
      link: "https://www.facebook.com/TrueSelfy",
    },
    {
      icon: <LinkedInIcon fontSize="large" />,
      link: "https://www.linkedin.com/showcase/trueselfy/",
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#000",
        py: 2,
        px: { xs: 2, md: 12, lg: 20 },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: "column", lg: "row" },
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {/* Links */}
      <Box
        sx={{
          display: "flex",
          gap: { xs: 2, md: 4 },
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: { xs: "center", md: "center", lg: "flex-start" },
        }}
      >
        {footerLinks.map((item) => {
          const isInternalLink = item?.link?.startsWith("/");
          const isCurrentPath = isInternalLink && location.pathname === item.link;
          if (isCurrentPath) return null;

          return (
            <Link
              key={item?.key}
              href={item?.link}
              target={isInternalLink ? "_self" : "_blank"}
              rel={!isInternalLink ? "noopener noreferrer" : undefined}
              sx={{
                color: "#fff",
                fontSize: { xs: 14, md: 16 },
                textDecoration: "underline",
                "&:hover": { color: "#d3d3d3" },
              }}
            >
              {item?.label}
            </Link>
          );
        })}
      </Box>

      {/* Copyright + Social */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
          flexDirection: { xs: "column", md: "column", lg: "row" },
        }}
      >
        <Copyright />
        <Box sx={{ display: "flex", gap: 1 }}>
          {socialLinks.map((item, i) => (
            <Link
              key={i}
              href={item.link}
              target="_blank"
              sx={{
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                backgroundColor: "transparent",
                color: "#fff",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#fff",
                  color: "#000",
                  transform: "scale(1.1)",
                },
              }}
            >
              {item.icon}
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
